import BaseService from "@/boot/BaseService";
class ProductoService extends BaseService {
    constructor() {
        super(null, "/productos");
    }
    async search(query) {
        return await this.post("/search", { query });
    }
    async image(formData) {
        return await this.post("/image", formData);
    }
}

export default new ProductoService();
